<app-card-shell
  [cardModel]="cardModel"
  [backgroundStyle]="backgroundStyle"
  [borderCssClass]="borderCssClass"
  [cardTypeClass]="'safety'"
  [cardTypeCss]="cardTypeCss"
  [cardSelected]="cardSelected"
  [dragDisabled]="dragDisabled"
  [dragStartDelay]="dragStartDelay"
  [controls]="controls"
  [editMode]="_editMode"
  [isEditable]="isEditable"
  [flip]="flip"
  (cardAction)="onShellCardAction($event)"
  (userAttributes)="userAttributes.emit($event)"
>
  <app-card-category-icon
    [category]="category ?? ''"
    [iconFolder]="'safety-cards'"
    [iconPrefix]="'category-'"
    [iconColorClass]="iconColorClass"
    [isMediaCard]="isMediaCard"
    [mediaIcon]="mediaIcon"
  ></app-card-category-icon>
  <app-card-content
    [cardHtml]="cardHtml"
    [periodMinutes]="periodMinutes"
    [flip]="flip"
    [cardDescription]="cardModel?.cardDescription ?? null"
    [editMode]="_editMode"
    [isEditable]="isEditable"
    [isUneditedCustom]="isBlankPlaceholder"
    [cardTypeCss]="cardTypeCss"
    [showFlipIcon]="controls.showFlipIcon ?? false"
    [flipAnchor]="controls.flipAnchor ?? null"
    (flipClicked)="flipCard()"
    (editClicked)="openEditDialog()"
  ></app-card-content>
</app-card-shell>
